import React from 'react';
import { FiCheck } from 'react-icons/fi';
import Button from '../Button';

function Image({ img = undefined }) {
  if (!img || !img.image_src) return null;
  return (
    <img
      className="max-h-16 lg:max-h-24 mb-0 mx-auto"
      src={img.image_src}
      alt={img.alt || ''}
    />
  );
}

export default function PartnerHero({
  title = '',
  description = '',
  img = {},
  cta = {},
  features = [],
  bgColor = 'var(--stone)',
  textColor = 'var(--text-dark)',
  terms,
}) {
  return (
    <div
      className="pt-40 pb-10 lg:pt-56 lg:pb-20"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="max-width text-center">
        <div className="grid justify-center justify-items-center whitespace-normal gap-6 lg:gap-10 max-w-4xl my-0 mx-auto lg:whitespace-pre-line">
          {img?.location === 'top' ? <Image img={img} /> : null}

          {title && (
            <h1 className="p-0 mb-0 mx-auto text-4xl lg:text-5xl lg:leading-[1.15] max-w-3xl">
              {title}
            </h1>
          )}

          {description && (
            <p className="p-0 lg:px-10 mb-0 mx-auto leading-relaxed text-base max-w-3xl">
              {description}
            </p>
          )}

          {cta?.cta_text && cta?.cta_url ? (
            <Button href={cta.cta_url} yellow solid>
              {cta.cta_text}
            </Button>
          ) : null}
          {terms}

          {img?.location === 'bottom' ? <Image img={img} /> : null}

          {features?.length > 0 ? (
            <div className="gap-2 flex-col flex lg:gap-12 lg:flex-row items-center">
              {features.map((f, i) => (
                <div
                  key={i}
                  className="mt-0 lg:mt-16 flex items-center text-left leading-[1.1]"
                >
                  <FiCheck size={22} />
                  <span>{f.feature}</span>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
